<div class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-sm p-0">
    <span class="arrow"></span>
    <div class="sp-head sp-head--sm container">
        <div class="sp-head__title header_setting">Usuario</div>
    </div>
    <hr class="solid m-0">
    <ul class="sp-nav sp-margin-b-10">
        <li class="sp-nav__item">
            <a class="sp-nav__link" [routerLink]="['/miPerfil']" routerLinkActive="router-link-active">
                <span class="sp-nav__link-icon mr-2" >
                    <i class="fa-solid fa-user circle"></i>
                </span>
                <span class="sp-nav__link-text">Mi perfil</span>
            </a>
        </li>
        <li class="sp-nav__item"> 
            <a class="sp-nav__link" routerLink="/pageTabPanel"   (click)="getDataagend()" routerLinkActive="router-link-active">
                <span class="sp-nav__link-icon mr-2">
                    <i class="fa-solid fa-calendar circle"></i>
                </span>
                <span class="sp-nav__link-text">Agenda</span>
            </a>
        </li>
        <li class="sp-nav__item"> 
            <a class="sp-nav__link" routerLink="/pageTabPanel"   (click)="getDataalertpanel()" routerLinkActive="router-link-active">
                <span class="sp-nav__link-icon mr-2">
                    <i class="fa-solid fa-exclamation-circle circle"></i>
                </span>
                <span class="sp-nav__link-text">Alertas</span>
            </a>
        </li>
        <!-- <li class="sp-nav__item">
            <a class="sp-nav__link no-arrow no-hover">
                <span class="sp-nav__link-icon mr-2">
                    <i class="fa-solid fa-language circle "></i>
                </span>
                <span class="sp-nav__link-text">Cambiar idioma: </span>
                <span type="button"><img class="lang mr-2" src="assets/img/lang-es.png" alt=""></span>
                <span type="button"><img class="lang mr-2" src="assets/img/lang-en.png" alt=""></span>
            </a>
        </li> -->
        <!-- <li class="dropdown sp-nav__item" (click)="stopPropagation($event)">
            <button aria-label="Desplegar acerca de" class="dropdown-toggle sp-nav__link-select w-100" id="dropdownMenuLink" aria-haspopup="true" aria-expanded="false" (click)="toggleSubmenu()" [ngClass]="{'rotated': submenuOpen}">
                <span class="sp-nav__link-icon mr-2">
                    <i class="fa-solid fa-circle-info circle"></i>
                </span>
                <span class="sp-nav__link-text text-start">Acerca de</span>
            </button>
            <div class="" aria-labelledby="dropdownMenuLink" [ngClass]="{'dropdown-submenu': submenuOpen, 'submenu': !submenuOpen}"> 
                <ul class="sp-nav">
                    <li class="sp-nav__item">
                        <a class="sp-nav__link" (click)="openModal('Políticas de privacidad')">
                            <span class="sp-nav__link-icon mr-2">
                                <i class="fa-solid fa-lock circle"></i>
                            </span>
                            <span class="sp-nav__link-text">Políticas de privacidad</span>
                        </a>
                    </li>
                    <li class="sp-nav__item">
                        <a  class="sp-nav__link" (click)="openModal('Términos y condiciones')">
                            <span class="sp-nav__link-icon mr-2">
                                <i class="fa-solid fa-scroll circle"></i>
                            </span>
                            <span class="sp-nav__link-text">Términos y condiciones</span>
                        </a>
                    </li>
                    <li class="sp-nav__item">
                        <a class="sp-nav__link no-arrow no-hover">
                            <span class="sp-nav__link-icon mr-2">
                                <i class="fa-solid fa-copyright circle"></i>
                            </span>
                            <span class="sp-nav__link-text"> Version Ophelia {{version}}</span>
                        </a>
                    </li>
                    <li class="sp-nav__item">
                        <a class="sp-nav__link no-arrow no-hover">
                            <span class="sp-nav__link-icon mr-2">
                                <i class="fa-solid fa-users-gear circle"></i>
                            </span>
                            <span  *ngIf="user$ | async as _user" class="sp-nav__link-text">
                                Usuarios activos: {{ _user.firstname}} 
                                <br>Contratos activos: {{ _user.id}}
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
        </li> -->
    </ul>
</div>

<ng-template #politicasModal let-modal>
    <button class="close modal-close text-dark" type="button" aria-label="Cerrar" (click)="modalRef.close(); $event.stopPropagation();">
      <i class="la la-times"></i>
    </button>
    <h3 class="sp-portlet__form-title prt-mep mt-5 text-center title">{{titleModal}}</h3>
    <div class="modal-body text-center modal-lg py-0">
     <p style="white-space: pre-line;text-align: justify;">{{textModal}}</p>
    </div>
</ng-template>